import { ROUTE_HANDLER } from "src/configs/messageRegistration";

const state = {
  messages: [],
  taskList: JSON.parse(localStorage.getItem('task_list') || '[]') || [],
};

const getters = {
  message: (state) => {
    return state.messages;
  },
  taskList: (state) => {
    return state.taskList;
  }
};

const actions = {
  async ioInterceptor({ dispatch, state }, payload) {
    /* Each interceptor channel will have a unique name, which will be used to route the message to the correct handler */
    /* Currently, it only serves requests to store modules so make sure you register the action "messageHandler" in the store module*/
    if (ROUTE_HANDLER[payload.channel] && state.taskList.includes(payload.taskId)) {
      dispatch(`${ROUTE_HANDLER[payload.channel]}/messageHandler`, payload, { root: true });
    }
  },

  /* this is a generic action that provides maintenance on users tasks */
  addTask({ commit, state }, taskId) {
    // push task id to the task list in local storage and then commit to the store
    if (taskId) {
      let taskList = state.taskList;
      taskList.push(taskId);
      localStorage.setItem('task_list', JSON.stringify(taskList));
      commit('setTaskList', taskList);
    }
  },

  removeTask({ commit }, taskId) {
    // remove task id from the task list in local storage and then commit to the store
    if (taskId) {
      let taskList = JSON.parse(localStorage.getItem('task_list') || '[]') || [];
      taskList = taskList.filter((item) => item !== taskId);
      localStorage.setItem('task_list', JSON.stringify(taskList));
      commit('setTaskList', taskList);
    }
  }
};

// mutations
const mutations = {
  setMessage (state, message) {
    state.messages.push(message);
  },
  setTaskList (state, payload) {
    state.taskList = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
